import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Modal, Field } from '../ui/Modal';
import { Icon } from '../ui/Icon';
import { api, ApiError } from '../../lib/api';
import { toast } from '../../stores/toast.store';
import { CandidateStage } from '@masamune/shared';

export function NewCandidateModal({ onClose }: { onClose: () => void }) {
  const qc = useQueryClient();
  const [form, setForm] = useState({
    firstName: '', lastName: '', email: '', phone: '', city: '',
    skill: '', seniority: 'Junior' as 'Junior' | 'Mid' | 'Senior',
    stage: CandidateStage.NUOVO_CANDIDATO as string,
    availability: 'Immediata', notes: '',
  });

  const create = useMutation({
    mutationFn: () => api.post('/candidates', form),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['candidates'] });
      toast.ok('Candidato creato', `${form.firstName} ${form.lastName}`);
      onClose();
    },
    onError: (err) => toast.alert('Errore creazione candidato', err instanceof ApiError ? err.message : 'Riprova'),
  });

  return (
    <Modal
      title="Nuovo candidato"
      kicker="Talent · Pipeline"
      onClose={onClose}
      size="lg"
      footer={
        <>
          <button className="btn btn-ghost" onClick={onClose}>Annulla</button>
          <div className="spacer" />
          <button className="btn btn-primary" onClick={() => create.mutate()} disabled={!form.firstName || !form.lastName || create.isPending}>
            Crea candidato <Icon name="arrowRight" size={12} />
          </button>
        </>
      }
    >
      <div className="form-grid">
        <Field label="Nome" required span={6}>
          <input className="inp" value={form.firstName} onChange={(e) => setForm({ ...form, firstName: e.target.value })} />
        </Field>
        <Field label="Cognome" required span={6}>
          <input className="inp" value={form.lastName} onChange={(e) => setForm({ ...form, lastName: e.target.value })} />
        </Field>
        <Field label="Email" span={6}>
          <input className="inp" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
        </Field>
        <Field label="Telefono" span={6}>
          <input className="inp" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
        </Field>
        <Field label="Città" span={4}>
          <input className="inp" value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} />
        </Field>
        <Field label="Competenza" span={4}>
          <input className="inp" placeholder="es. Frontend, UX/UI" value={form.skill} onChange={(e) => setForm({ ...form, skill: e.target.value })} />
        </Field>
        <Field label="Seniority" span={4}>
          <div className="seg-control">
            {(['Junior', 'Mid', 'Senior'] as const).map((s) => (
              <button key={s} aria-pressed={form.seniority === s} onClick={() => setForm({ ...form, seniority: s })}>{s}</button>
            ))}
          </div>
        </Field>
        <Field label="Disponibilità" span={6}>
          <input className="inp" value={form.availability} onChange={(e) => setForm({ ...form, availability: e.target.value })} />
        </Field>
        <Field label="Stage pipeline" span={6}>
          <select className="inp" value={form.stage} onChange={(e) => setForm({ ...form, stage: e.target.value })}>
            {Object.values(CandidateStage).map((s) => <option key={s} value={s}>{s.replace(/_/g, ' ')}</option>)}
          </select>
        </Field>
        <Field label="Note" span={12}>
          <textarea className="inp" rows={3} value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} />
        </Field>
      </div>
    </Modal>
  );
}
